import { render, staticRenderFns } from "./contactSubmissions.vue?vue&type=template&id=4389bcce&scoped=true"
import script from "./contactSubmissions.vue?vue&type=script&lang=js"
export * from "./contactSubmissions.vue?vue&type=script&lang=js"
import style0 from "./contactSubmissions.vue?vue&type=style&index=0&id=4389bcce&prod&scoped=true&lang=scss"
import style1 from "./contactSubmissions.vue?vue&type=style&index=1&id=4389bcce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4389bcce",
  null
  
)

export default component.exports